import { render } from "./Header.vue?vue&type=template&id=011cd604&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=011cd604&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ShelfDat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011cd604"]])

export default __exports__